{
  "update-password-pin-dialog": {
    "buttons": {
      "resend": "Znovu odeslat",
      "submit": "Odeslat"
    },
    "text": {
      "enter-pin": "Zadejte prosím kód PIN pro potvrzení nového hesla.",
      "in-second": "v {{seconds}} s",
      "password-updated": "Heslo bylo úspěšně aktualizováno!",
      "pin-via-email": "Kód PIN je zaslán na váš e-mail",
      "pin-via-sms": "Kód PIN je zaslán na vaše telefonní číslo",
      "update-password": "Aktualizace hesla"
    }
  }
}
